import { render, staticRenderFns } from "./ProjectAlternatives.vue?vue&type=template&id=b6c57522&scoped=true"
import script from "./ProjectAlternatives.vue?vue&type=script&lang=js"
export * from "./ProjectAlternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c57522",
  null
  
)

export default component.exports